export default __webpack_public_path__ + "static/media/phone.7c2c66cb.png";